function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomTatamiFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.709 3.709h22.583a1 1 0 011 1v22.583a1 1 0 01-1 1H4.709a1 1 0 01-1-1V4.709a1 1 0 011-1zM19 26.292H5.709V20H19v6.292zm2 0h5.292V13H21v13.292zM26.292 11V5.709H14V11h12.292zM5.709 18H12V5.709H5.709V18zM19 18v-5h-5v5h5z",
    fill: props.color
  }));
}

export default SvgIconRoomTatamiFilled;